/*
 * sorting-keys-enum.ts
 * utms-admin-dashboard
 * 
 * Last Modified: 15.07.2024
 * Modified By: Tetiana Makovii
 * 
 * Created by Tetiana Makovii on 14.07.2024
 * Copyright © 2026 Sonova AG. All rights reserved.
 */

export enum SortingKeysEnum
{
    lastName = "lastName",
    patientId = "patientId",
    email = "email",
    shopId = "shopId",
    lastSeen = "lastSeen",
    dateOfRegistration = "dateOfRegistration"
}
